import './Call.css'
import React from 'react'
import img1 from '../img/bg-pattern-light.png'

function Call() {
  const createWhatsAppLink = () => {
    const message = `السلام عليكم، أريد الحصول على إستشارة مجانية`;
    return `https://wa.me/966568300288?text=${encodeURIComponent(message)}`;
  };
  return (
    <div className='call'>
       <div className='color-overlay'></div>
       <div className="container">
            <div className="row">
                <div className='col-12'>
                <h2 className='callh2'>احصل على استشارتك المجانية الآن!</h2>
                <p className='pcall'>نحن نقدم حلولاً مخصصة تلبي احتياجاتك. فريقنا من الخبراء جاهز لمساعدتك في كل خطوة. لا تتردد في التواصل معنا للحصول على استشارة مجانية.</p>
                <a href={createWhatsAppLink()}class="cta-button"   rel="nofollow"
                target="_blank">تواصل معنا الآن</a>
                </div>
            </div>
        </div>
        <div className='bottom-pattern '>
            <img src={img1} alt="back" />
        </div>
    </div>
  )
}

export default Call
